//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import UiSelectionBtn from "@/components/Ui/UiSelectionBtn.vue";

const GROUP_TYPES = {
  characterEngraving: 'characterEngraving',
  gemstone: 'gemstone'
}

export default {
  components: {UiSelectionBtn},
  props: {
    margin: {
      type: Number,
      default: 0
    },
    selectedStones: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: -1
    },
    stoneTypes: {
      type: Array,
      required: true
    },
    info: {
      type: Object,
      required: true
    },
    symbols: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      placement: null,
      activeTab: GROUP_TYPES.gemstone,
      GROUP_TYPES
    }
  },
  computed: {},
  methods: {
    indexChange(i) {
      this.$emit('indexChange', i)
    },
    changeST(el) {
      this.$emit('changeST', el)
    },
    setDefaultActiveTab() {
      const isCharacterEngraving = this.symbols.find(i => this.selectedStones[this.index].st?.value === i?.value)

      if (isCharacterEngraving) {
        this.activeTab = GROUP_TYPES.characterEngraving
      } else {
        this.activeTab = GROUP_TYPES.gemstone
      }
    }
  },
  mounted() {
    this.setDefaultActiveTab()
  }
}
